import { getPriceAnatomyListStyles, getPriceAnatomyListItemStyles, getPriceAnatomyParagraphStyles } from './PriceAnatomyStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const PriceAnatomy = _ref => {
  let {
    items
  } = _ref;
  return jsx("ul", {
    css: getPriceAnatomyListStyles,
    children: items.map((item, index) => jsx("li", {
      css: getPriceAnatomyListItemStyles,
      children: jsxs("p", {
        css: getPriceAnatomyParagraphStyles,
        children: [item.key, ": ", jsx("strong", {
          children: item.value
        })]
      })
    }, index))
  });
};

export { PriceAnatomy };
//# sourceMappingURL=PriceAnatomy.js.map
